module.exports = "/_next/static/images/1-35b0ebaea96bfd8218fc8195f4f8e1ab.jpg";